export const Job = {}
export const JobWizard = { ExclusiveJob: {}, Offers: {} }
export const JobWizardMobile = { ExclusiveJob: {} }
